import React, { useState } from "react";
import {Grid } from '@material-ui/core';
import { Box, Card, CardContent, Alert, AlertTitle, Button } from '@mui/material';
import MainCard from '../components/MainCard';
import StickyHeadOneButtonTable from '../components/StickyHeadOneButtonTable';
import axios from "../../components/axios";
import CustomDatePicker from '../components/CustomDatePicker';
import { useNavigate } from 'react-router-dom';
import { format, isValid } from 'date-fns';
import { Dialog, DialogContent, DialogTitle } from '@mui/material';


const VoiceTestPage = () => {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [showTable, setshowTable] = useState(false);
  const [showAlert, setshowAlert] = useState(false);
  const [clickCalendar, setclickCalendar] = useState(0);
  const [open, setOpen] = useState(false);
  const [dialog, setDialog] = useState(false);
  const [data, setData] = useState({});

  const onChange = (ranges) => {
    if (clickCalendar === 0 ){
      setclickCalendar(clickCalendar+1)
    }else{
      setclickCalendar(0)
      if (ranges.startDate !== null && ranges.endDate !== null) {
        setOpen(false);
      }
    }
  };

  const [state, setState] = useState([
    {
      startDate: null,
      endDate: null,
      key: "selection"
    }
  ]);

  const styleButton = {
    backgroundColor: "#406599",
    color: "#fff",
    borderRadius: "5px",
    boxSizing: "border-box",
    width: "100px",
    height: "45px",
    fontFamily: '"Roboto", "sans-serif"',
    fontSize: "15px",
  };

  const handleQueryData = () => {
    console.log(state)
    if (state[0].startDate === null && state[0].endDate === null ){
      alert("Please select query date range or keyword!");
    }else{
      setRows([]);
      let startDateStr = "";
      let endDateStr = ""
      if (state[0].startDate !== null && isValid(state[0].startDate)) {
        startDateStr = format(state[0].startDate, "yyyy-MM-dd")
      }
      if (state[0].endDate !== null && isValid(state[0].endDate)) {
        endDateStr = format(state[0].endDate, "yyyy-MM-dd")
      }

      var input_data = JSON.stringify({ query: "", start_date: startDateStr,
        end_date: endDateStr, condition: "and" })
      axios.post("/peloton/v1/automation/query-voice-tests",input_data,{withCredentials: true})
      .then(response => {
        if (response.data.message === "success") {
          if (response.data.data !== null){
            setRows(response.data.data);
            setshowTable(true);
          }else{
            setshowAlert(true);
          }
        }else{
          alert(response.data.message);
        }
      }).catch(function(err){
        if (!err.response){
          alert(err);
        }else{
          if (err.response.status === 401){
            navigate("/");
          }else{
            console.log('error.response.status: ', err.response.status);
            console.log('error.response.status: ', err.response.data.message);
            alert(err.response.data.message);
          }
        }
      })
    }
  };

  const handleDetail = (uuid) => {
    setData(JSON.stringify(JSON.parse(uuid), null, 2));
    setDialog(true);
  };

  const handleClose = () => {
    setDialog(false);
  };

const columns = [
  { id: 'token', label: 'Token' , align: 'left'},
  { id: 'update_time', label: 'Trigger Time', align: 'center'},
  { id: 'finish_time', label: 'Finish Time', align: 'center'},
  { id: 'is_finish', label: 'Is Finish', align: 'center'},
  { id: 'action', label: 'Data', align: 'center', action: true},
];

  return (
    <MainCard title="Tiger Voice tests">
      <Card variant="outlined" sx={{ bgcolor: "white" }}>
      <CardContent>
      <Box sx={{ fontSize: '20px', color:"#406599", pb:'15px'}}>
      Tiger Voice tests
      </Box>
      <Grid container direction="row" justifyContent="space-around" alignItems="center" >
        <Grid item xs={5}>
        <CustomDatePicker onChange={onChange} open={open} setOpen={setOpen} state={state} setState={setState}/>
        </Grid>
        <Grid item xs={2}>
        </Grid>
        <Grid item xs={2}>
          <Button style={styleButton} onClick={handleQueryData}>Search</Button>
        </Grid>
      </Grid>
      </CardContent>
      </Card>
      <Dialog
        open={dialog}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"JSON Data"}
          </DialogTitle>
          <DialogContent>
            <div><pre>{data}</pre></div>
          </DialogContent>
        </Dialog>

      { showTable && (<StickyHeadOneButtonTable rows={rows} columns={columns} handleDetail={handleDetail} title="Tiger Voice Tests"/>)}
      { showAlert && (<Card variant="outlined" sx={{ bgcolor: "white" }}><Alert severity="warning">
        <AlertTitle>Warning</AlertTitle>
        No data in this condition.
      </Alert></Card>)}
    </MainCard>)
};

export default VoiceTestPage;
